var _rect, _rect2, _rect3, _rect4, _path, _line, _line2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinkCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 252,
    viewBox: "0 0 427 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 397,
    height: 195,
    fill: "#A9633C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 377,
    height: 47,
    fill: "#E1976D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 93,
    width: 377,
    height: 116,
    fill: "#E1976D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 426,
    height: 25,
    fill: "#C87749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 220H413L427 252H7L16 220Z",
    fill: "#C87749"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    y1: 93,
    x2: 207,
    y2: 209,
    stroke: "#7F6969",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    y1: 40,
    x2: 207,
    y2: 88,
    stroke: "#7F6969",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 147.5,
    r: 7.5,
    fill: "#984B20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 148.5,
    r: 7.5,
    fill: "#984B20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinkCabinet);
export default __webpack_public_path__ + "static/media/sink_cabinet.5bd17dad3823dad1ebe6646d7cfd32d6.svg";
export { ForwardRef as ReactComponent };